import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing }) => ({
  container: {
    display: 'flex',
    paddingBottom: spacing(Theme.Spacing.Medium),
    paddingTop: 0,
    justifyContent: 'center',
    textAlign: 'center',
  },
  dateText: {
    margin: 0,
    lineHeight: 1.2,
  },
  text: {
    fontSize: spacing(12),
  },
}))
